import React from 'react';
import ReactDOM from 'react-dom';

import PageMock from './PageMock.jsx';

const root = document.getElementById('mock');

if (root) {
  ReactDOM.render(<PageMock />, root);
}
